import { Location } from '../__types';

const locations: Location[] = [
  {
    id: 'bree',
    coords: { x: 2260, y: 1350 },
  },
  {
    id: 'hobbiton',
    coords: { x: 1836, y: 1323 },
  },
  {
    id: 'erebor',
    coords: { x: 4360, y: 864 },
  },
  {
    id: 'brandywineBridge',
    coords: { x: 1996, y: 1294 },
  },
  {
    id: 'oldForest',
    coords: { x: 2083, y: 1386 },
  },
  {
    id: 'lastBridge',
    coords: { x: 2890, y: 1280 },
  },
  {
    id: 'rivendell',
    coords: { x: 3228, y: 1288 },
  },
  {
    id: 'moriaGate',
    coords: { x: 3127, y: 1854 },
  },
  {
    id: 'lorien',
    coords: { x: 3445, y: 2020 },
  },
  {
    id: 'isengard',
    coords: { x: 2949, y: 2545 },
  },
  {
    id: 'esgaroth',
    coords: { x: 4363, y: 987 },
  },
  {
    id: 'deadMarshes',
    coords: { x: 4200, y: 2872 },
  },
  {
    id: 'minasMorgul',
    coords: { x: 4339, y: 3283 },
  },
  {
    id: 'minasTirith',
    coords: { x: 4230, y: 3290 },
  },
  {
    id: 'baradDur',
    coords: { x: 4767, y: 3126 },
  },
  {
    id: 'ironHills',
    coords: { x: 5170, y: 921 },
  },
  {
    id: 'udun',
    coords: { x: 4450, y: 2955 },
  },
  {
    id: 'drimrillDale',
    coords: { x: 3244, y: 1828 },
  },
  {
    id: 'seaOfRhun',
    coords: { x: 5760, y: 2026 },
  },
  {
    id: 'rohan',
    coords: { x: 3445, y: 2631 },
  },
  {
    id: 'gondor',
    coords: { x: 3325, y: 3390 },
  },
  {
    id: 'dolGuldur',
    coords: { x: 3868, y: 1968 },
  },
  {
    id: 'eastBight',
    coords: { x: 4294, y: 1708 },
  },
  {
    id: 'fangorn',
    coords: { x: 3294, y: 2382 },
  },
  {
    id: 'farDowns',
    coords: { x: 1615, y: 1383 },
  },
  {
    id: 'weatherHills',
    coords: { x: 2500, y: 1164 },
  },
  {
    id: 'weathertop',
    coords: { x: 2553, y: 1293 },
  },
  {
    id: 'oldForestRoad',
    coords: { x: 4062, y: 1218 },
  },
  {
    id: 'mordor',
    coords: { x: 5205, y: 3400 },
  },
  {
    id: 'shire',
    coords: { x: 1765, y: 1220 },
  },
  {
    id: 'brandywine',
    coords: { x: 1816, y: 1891 },
  },
  {
    id: 'trollshaws',
    coords: { x: 3051, y: 1266 },
  },
  {
    id: 'mitheithel',
    coords: { x: 2862, y: 1515 },
  },
  {
    id: 'emynMuil',
    coords: { x: 4002, y: 2694 },
  },
  {
    id: 'orodruin',
    coords: { x: 4614, y: 3154 },
  },
  {
    id: 'morannon',
    coords: { x: 4407, y: 2877 },
  },
  {
    id: 'mirkwood',
    coords: { x: 4044, y: 1480 },
  },
  {
    id: 'rhun',
    coords: { x: 6103, y: 1164 },
  },
  {
    id: 'rhovanion',
    coords: { x: 4689, y: 2032 },
  },
  {
    id: 'arnor',
    coords: { x: 2643, y: 840 },
  },
  {
    id: 'forodwaith',
    coords: { x: 3646, y: 380 },
  },
  {
    id: 'eriador',
    coords: { x: 2919, y: 1701 },
  },
  {
    id: 'anduin',
    coords: { x: 3687, y: 1776 },
  },
  {
    id: 'edoras',
    coords: { x: 3288, y: 2939 },
  },
];

export default locations;
